var _a;
import { __decorate, __metadata, __param } from "tslib";
import { getSearchCitationQueryApi } from '@cores/apis/workspace_api/patents';
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
import { Toast } from 'patsnap-biz';
import { rvTrack } from 'track';
import { ANALYTICS_URI } from '@cores/constants/envConfig';
import ptDialogAutoMounterManager from './PtDialogAutoMounterManager';
import { provide, inject } from '@/inversify.config';
import { DetailServiceSymbol } from './DetailService';
import { FolderSettingService } from '@/domains/detail/folder/types/folder-setting-service.interface';
import { getOptions } from 'library-@/AdvancedSearchForm/utils/fields';
const SearchCitationDialog = () => import('@/presentation/components/folders/SearchCitationDialog.vue');
export const SearchCitationServiceSymbol = Symbol.for('SearchCitationService');
let SearchCitationService = class SearchCitationService {
    constructor(detailService, pageSelectorService, folderSettingService) {
        this.detailService = detailService;
        this.pageSelectorService = pageSelectorService;
        this.folderSettingService = folderSettingService;
        this.loading = false;
        this.citeType = 'B_CITES';
        this.citeCategory = '';
        this.loading = false;
        this.citeType = 'B_CITES';
        this.citeCategory = '';
        ptDialogAutoMounterManager.register(SearchCitationDialog);
    }
    handleCitationOptionsChange(value) {
        this.citeCategory = value;
    }
    getCitationOptions() {
        return getOptions('CITE_CATEGORY', 'patent');
    }
    disabled({ selectedCount }) {
        return selectedCount > 1000;
    }
    open() {
        ptDialogAutoMounterManager.toggleOpenState(SearchCitationDialog, true);
    }
    close() {
        ptDialogAutoMounterManager.toggleOpenState(SearchCitationDialog, false);
        this.citeType = 'B_CITES';
    }
    search() {
        this.loading = true;
        const { folderId: folder_id, refiner, } = this.detailService;
        const sort = this.folderSettingService.folderSetting.current_sort;
        const { mode, rangeFrom, rangeTo, finalIds } = this.pageSelectorService;
        const { citeType, citeCategory } = this;
        getSearchCitationQueryApi({
            folder_id,
            cite_type: citeType,
            patent_ids: finalIds,
            refiner,
            select_mode: mode,
            sort,
            start: rangeFrom,
            end: rangeTo,
            cite_category: citeCategory,
        })
            .then(({ qid }) => {
            rvTrack('Search citation in workspace', {
                search_citation_type: citeType,
            });
            window.open(`${ANALYTICS_URI}/search/result?q=${qid}&_type=query`);
            this.close();
            this.loading = false;
        })
            .catch((error) => {
            this.loading = false;
            if (!error._error_msg)
                return;
            Toast({
                message: error._error_msg,
                type: 'error',
                showClose: true,
            });
        });
    }
};
SearchCitationService = __decorate([
    provide(SearchCitationServiceSymbol),
    __param(0, inject(DetailServiceSymbol)),
    __param(1, inject(PageSelectorServiceSymbol)),
    __param(2, inject(FolderSettingService)),
    __metadata("design:paramtypes", [Object, Object, typeof (_a = typeof FolderSettingService !== "undefined" && FolderSettingService) === "function" ? _a : Object])
], SearchCitationService);
export { SearchCitationService };
